<template lang="pug">
  b-navbar(toggleable="md", type="dark", :variant="$breakpoint.smDown ? 'primary' : toolbarVariant", fixed="top")
    b-container
      b-navbar-toggle(target="toolbar-menu", style="outline:none !important;border:0;position:relative;z-index:1;")

      b-collapse#toolbar-menu(is-nav, style="position:relative;z-index:1;")
        b-navbar-nav.mr-auto.justify-content-end(style="flex:1;padding-right:35px;")
          b-nav-item.mx-5(v-for="(item, index) in menu.slice(0,2)", v-scroll-to="{element: item.element, offset: -60}") {{ item.title }}
        b-navbar-nav.ml-auto.justify-content-start(style="flex:1;padding-left:35px;")
          b-nav-item.mx-5(v-for="(item, index) in menu.slice(2)", v-scroll-to="{element: item.element, offset: -60}") {{ item.title }}

      .brand-centered
        b-navbar-brand
          b-img(src="@/assets/logo.png", height="50",  v-scroll-to="{element: '#home', offset: -60}")
</template>

<script>
import menu from '@/data/menu'

export default {
  data () {
    return {
      menu: menu,
      toolbarVariant: 'transparent'
    }
  },
  mounted () {
    let self = this
    if (document.getElementsByTagName('html')[0].scrollTop >= 10) {
      this.toolbarVariant = 'primary'
    } else {
      this.toolbarVariant = 'transparent'
    }

    document.addEventListener('scroll', function () {
      if (document.getElementsByTagName('html')[0].scrollTop >= 10) {
        self.toolbarVariant = 'primary'
      } else {
        self.toolbarVariant = 'transparent'
      }
    })
  }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
  .brand-centered {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    z-index:0;
  }

  .navbar-brand {
    margin: 0 !important;
  }

  .navbar-dark .navbar-nav .nav-link {
    color: white !important;
  }

  .navbar-dark.bg-transparent .navbar-nav .nav-link {
    text-shadow: 2px 3px 5px #333;
  }
</style>
